export default __webpack_public_path__ + "static/media/icons8-cleaning.88124762.svg";